import Icon from '@tiger/icons';
import { FC } from 'react';
import { FormControl, FormLabel } from 'react-bootstrap';
import { $Listutil, EasyField } from 'react-bootstrap-formutil';
import Button from 'components/base/Button';
import Dialog from 'components/base/Dialog';
import Toast from 'components/Toast';
import deleteIcon from 'static/images/icon/delete.svg';
import editIcon from 'static/images/icon/edit.svg';
import { useDeleteContact } from '../hook';
import { TrustedContactPersonDataItem } from '../type';
import styles from './style.scss';

export interface ContactPersonListProps {
    maxNumber?: number;
    refresh?: () => void;
    $defaultValue?: TrustedContactPersonDataItem[];
    onAdd: () => void;
    onEdit: (data: TrustedContactPersonDataItem) => void;
}

const ContactPersonList: FC<ContactPersonListProps> = ({ maxNumber = 5, refresh, $defaultValue, onAdd, onEdit }) => {
    const { trigger: triggerDelete } = useDeleteContact();

    return (
        <EasyField<TrustedContactPersonDataItem[]>
            name="temporaryContactPerson"
            type="list"
            $defaultValue={$defaultValue}>
            {($listutil: $Listutil<TrustedContactPersonDataItem>) => {
                const { first_name, middle_initial, last_name, relationship, id } = $listutil.$params;
                // 受信人姓名没有name_type，这里手动拼接一下fullName
                const fullName = [first_name, middle_initial, last_name].filter(Boolean).join(' ');

                const handleDelete = () => {
                    Dialog.confirm({
                        content: __('Confirm to delete the current item?'),
                        size: 'sm'
                    })
                        .then(async () => {
                            try {
                                await triggerDelete(id);

                                Toast.show(__('Delete successfully'));

                                $listutil.$remove($listutil.$index);
                                refresh && refresh();
                            } catch (error) {
                                Toast.show(error);
                            }
                        })
                        .catch(() => {});
                };

                return (
                    <>
                        {fullName ? (
                            <div>
                                <div className={styles.infoItem}>
                                    <div className={styles.labelContainer}>
                                        <FormLabel className="mb-0">{`${__('Name')} ${
                                            $listutil.$index + 1
                                        }`}</FormLabel>
                                        <div className={styles.iconContainer}>
                                            <img
                                                onClick={handleDelete}
                                                className={styles.icon}
                                                src={deleteIcon}
                                                alt="delete"
                                                title={__('Delete')}
                                            />
                                            <img
                                                onClick={() => onEdit($listutil.$params)}
                                                className={styles.icon}
                                                src={editIcon}
                                                alt="edit"
                                                title={__('Edit')}
                                            />
                                        </div>
                                    </div>
                                    <FormControl value={fullName} disabled />
                                </div>
                                <div className={styles.infoItem}>
                                    <FormLabel>{__('Relationship')}</FormLabel>
                                    <FormControl value={relationship} disabled />
                                </div>
                                {!$listutil.$isLast() && <hr className={styles.divider} />}
                            </div>
                        ) : null}
                        {$listutil.$isLast() && $listutil.$length < maxNumber && (
                            <Button ghost type="dark" className={styles.addBtn} onClick={onAdd}>
                                <Icon className={styles.addIcon} type="plusCircle" />
                                {__('Add Trusted Contact Person')}
                            </Button>
                        )}
                    </>
                );
            }}
        </EasyField>
    );
};

export default ContactPersonList;
